import { baseUrlAssets as assets } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

const browseUrl = (connectedAccountId: number) =>
  `${assets}/autodesk/browse/${connectedAccountId}`;

export const endpointsAutodeskImport = {
  hubs: (connectedAccountId: number) => `${browseUrl(connectedAccountId)}/hubs`,
  projects: (connectedAccountId: number, hubId: string, region: string) =>
    `${browseUrl(connectedAccountId)}/hubs/${encodeURIComponent(hubId)}/projects?region=${encodeURIComponent(region)}`,
  topFolders: (
    connectedAccountId: number,
    hubId: string,
    projectId: string,
    region: string,
  ) =>
    `${browseUrl(connectedAccountId)}/hubs/${encodeURIComponent(hubId)}/projects/${encodeURIComponent(projectId)}/topfolders?region=${encodeURIComponent(region)}`,
  folderContents: (
    connectedAccountId: number,
    projectId: string,
    folderId: string,
    region: string,
  ) =>
    `${browseUrl(connectedAccountId)}/projects/${encodeURIComponent(projectId)}/folders/${encodeURIComponent(folderId)}/contents?region=${encodeURIComponent(region)}`,
  selectionPreview: {
    method: "POST",
    url: `${assets}/autodesk/import/selection/preview`,
  } as Endpoint,
  selection: {
    method: "POST",
    url: `${assets}/autodesk/import/selection`,
  } as Endpoint,
};
